import { useState } from "react";

const getTarget = () => {
  const now = new Date();
  const month = now.getMonth(); // Oct = 9, May = 4
  if (month >= 9 || month <= 4) {
    const year = month <= 4 ? now.getFullYear() : now.getFullYear() + 1;
    return { target: new Date(year, 5, 1), mode: "closes" }; // season ends June 1
  }
  return { target: new Date(now.getFullYear(), 9, 1), mode: "opens" }; // opens Oct 1
};

const Countdown = () => {
  const [{ target, mode }] = useState(getTarget);
  const days = Math.max(0, Math.ceil((target - new Date()) / 86400000));

  return (
    <div data-testid="season-countdown" className="mt-14">
      <p className="text-xs uppercase tracking-[0.3em] text-champagne">
        {mode === "opens" ? "The season opens in" : "The season is open — it closes in"}
      </p>
      <div className="mt-6 flex items-baseline justify-center gap-4">
        <span
          data-testid="countdown-days"
          className="font-serif text-6xl font-light tabular-nums text-offwhite sm:text-7xl"
        >
          {days}
        </span>
        <span className="text-[10px] uppercase tracking-[0.3em] text-cream/45">
          Days
        </span>
      </div>
    </div>
  );
};

export default Countdown;
